import { render, staticRenderFns } from "./QuantitativeAssessmentModal.vue?vue&type=template&id=aa0b1506&scoped=true&"
import script from "./QuantitativeAssessmentModal.vue?vue&type=script&lang=js&"
export * from "./QuantitativeAssessmentModal.vue?vue&type=script&lang=js&"
import style0 from "./QuantitativeAssessmentModal.vue?vue&type=style&index=0&id=aa0b1506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0b1506",
  null
  
)

export default component.exports